














































































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class LogBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly fetchDepositWithdraw!: Function;

  @Prop() readonly openDetail!: Function;

  @Prop() readonly currencyRate!: object;

  @Prop() readonly currency!: string;

  utilsInstance = utils;

  sum = {
    totalCreditDeposit: 0,
    totalCreditWithdraw: 0,
    creditBalance: 0,
    totalAutoDeposit: 0,
    totalAutoWithdraw: 0,
    autoBalance: 0,
  };

  handleSub(username, role, source) {
    this.fetchDepositWithdraw(username, role, source);
  }

  created() {
    this.sumFooter();
  }

  sumFooter() {
    Object.keys(this.sum).forEach((key) => {
      this.sum[key] = this.data.reduce((acc, cur: any) => (acc + cur[key]), 0);
    });
  }

  calRate(value: number) {
    return value;
  }
}
